'use strict';
import React, { useEffect } from 'react';
import { ProjectItem } from './ProjectItem.jsx';
import MolecularHome from '../MolecularHome.jsx';
import './MyProjects.scss';
import { useProjectsQuery as useDiscoveryQuery } from '@/redux/services/discovery/projects.api';
import { useDispatch } from 'react-redux';
import { reset } from '@/redux/reducers/sampleSetData.reducer.js';
import { useProjectsQuery } from '@/redux/services/portal/projects.api.js';
import { Logger, Log } from '../../../utils/Logger';
import { AppInsightLogLevel } from '../../../enums/Enums';

const logger = new Logger();

export const getProjectItems = (projectList, discoveryPanels, mapData, onSelect) => {
	if (mapData) {
		projectList = projectList.map((data) => {
			Object.keys(mapData).forEach((key) => {
				data[key] = data[mapData[key]];
			});
			return data;
		});
	}

	let sortedProjects = projectList.sort(function (a, b) {
		try {
			let nameA = a.projectCode.toLowerCase(), nameB = b.projectCode.toLowerCase();
			if (nameA < nameB) { return -1; }
			if (nameA > nameB) { return 1; }
			return 0;
		}
		catch (err) {
			let nullProjectId = a.projectCode == null ? a.projectId : b.projectId;
			throw new Error(
				`Missing ProjectCode for projectId: ${nullProjectId}, Exception: ${err}`
			);
		}
	});

	const projects = [];
	sortedProjects.forEach(project => {
		const isDiscoveryPanel = discoveryPanels ? project.projectId in discoveryPanels : false;
		if (isDiscoveryPanel) {
			projects.push(<ProjectItem key={project.projectId + "SP"} project={project} isDiscoveryPanel={isDiscoveryPanel} onSelect={onSelect} />);
		} else {
			projects.push(<ProjectItem key={project.projectId} project={project} onSelect={onSelect} />);
		}
	});

	return projects;
};

export const MyProjects = (props) => {
	const { data: projects } = useProjectsQuery();
	const { data: discoveryPanels } = useDiscoveryQuery(projects?.map(p => p.projectId), { skip: !projects });
	const dispatch = useDispatch();

	useEffect(() => {
		if (window.location.pathname.indexOf("errortest") != -1) {
			throw new TypeError("ErrorTest");
		}
		dispatch(reset());
	}, [dispatch]);

	const logEvent = (property, value) => {
		let log = new Log();
		log.SetLevel(AppInsightLogLevel.ERROR);
		log.SetName(props.viewName);
		log.AddProperty(property, value);
		logger.doLog(log);
	};

	return (
		<div data-testid="my-projects" className="my-projects-container">
			<MolecularHome projects={projects || []} discoveryPanels={discoveryPanels} onLogEvent={logEvent} />
		</div>
	);
};

export default MyProjects;
